import { APP_PREVIEW_SET, PROTOTYPE_DISCLAIMER } from '@/content/screenshots';

/**
 * "Inside the app" gallery — shows the prototype screenshots inside lightweight phone frames.
 * Every screenshot block carries an advisory caption.
 */
export default function AppPreviewGallery() {
  return (
    <div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5 lg:gap-6">
        {APP_PREVIEW_SET.map((s, i) => (
          <figure key={i} className="group">
            <div
              className="relative mx-auto rounded-[28px] border border-vl-ink/15 bg-vl-bg2 shadow-[0_20px_50px_-25px_rgba(26,26,58,0.35)] overflow-hidden transition-transform group-hover:-translate-y-0.5"
              style={{ aspectRatio: '9 / 19' }}
            >
              <div className="absolute inset-1.5 rounded-[22px] overflow-hidden bg-vl-surface">
                <img
                  src={s.src}
                  alt={s.alt}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>
            <figcaption className="mt-3 text-xs text-vl-ink/60 text-center leading-snug">
              {s.alt.replace(/ \(prototype interface\)\.?$/, '')}
            </figcaption>
          </figure>
        ))}
      </div>

      <p className="mt-8 max-w-2xl text-xs text-vl-ink/55 leading-relaxed border-t hairline pt-5">
        {PROTOTYPE_DISCLAIMER}
      </p>
    </div>
  );
}
